__turbopack_context__.v({
  "accordion": "J-MsPW_accordion",
  "accordion-detail": "J-MsPW_accordion-detail",
  "accordion-summary": "J-MsPW_accordion-summary",
  "accordion-summary-text": "J-MsPW_accordion-summary-text",
  "hidden-content": "J-MsPW_hidden-content",
});
